module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_8_E_3.0ae64711.mp3";